export type maskNames = 'card'

export const MASKS: Record<maskNames, string> = {
  card: '#### #### #### #######',
}